// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 236) return "static/chunks/236-9ad40e99747ad3e6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"616":"89a72b41a7138979","5503":"12ccdf2ce5f2add2"}[chunkId] + ".js";
};